import { AFFILIATE_DEALS_PROXY_URL } from '../config';
import { withTokensIfNeeded } from '../utils/withTokensIfNeeded';
import { mapDealsToUIObjects } from './maps';
import { DealAPIResponse, DealUIObject } from './types';

export async function getTopDeals(limit: number = 100): Promise<DealUIObject[]> {
    const response = await withTokensIfNeeded<DealAPIResponse>(
        `${AFFILIATE_DEALS_PROXY_URL}&page[limit]=${limit}&order[rank]=DESC&filters[ends_at_gt]=${Math.floor(
            Date.now() / 1000
        )}`,
        {
            method: 'GET',
            mode: 'cors',
        }
    );

    const deals = response.data?.data || [];
    const dealsWithBrandIds = deals.filter((deal) => deal.attributes.brand_id);
    return mapDealsToUIObjects(dealsWithBrandIds);

    /* enable this instead if you want mock data: */
    // const mockDeals = generateDeals(123);
    // return mapDealsToUIObjects(mockDeals);
}
